export const share_http_v = "https://us-central1-newtopia-a4327.cloudfunctions.net/app/get-post?postid=";